<template>
  <b-card no-body class="bg-white border mb-2">
    <b-card-body class="d-flex align-items-center p-2">
      <div class="professions-item mr-1">
        <div class="d-flex align-items-center">
          <div class="w-100 d-flex align-items-center flex-nowrap min-w-0" :class="[{ 'fw-bolder': top }]">
            <span class="text-portal-primary mr-2" style="flex-shrink: 0;" v-if="top">TOP {{ index }}</span>
            <span
              v-if="showRankBars && rankLevel && infTooltip"
              class="mr-2 professions-item__rank-bars flex-no-shrink"
              v-b-tooltip.hover.html.bottom="{ customClass: 'profession-info-tooltip' }"
              :title="infTooltip"
            >
              <qualification-level-bars :level="rankLevel" />
            </span>
            <span v-else-if="showRankBars && rankLevel" class="mr-2 professions-item__rank-bars flex-no-shrink">
              <qualification-level-bars :level="rankLevel" />
            </span>
            <span class="text-truncate flex-grow-1 min-w-0 d-block">{{ title }}</span>
          </div>

        </div>
      </div>
      <div class="ml-auto d-flex items-center">
        <b-button
          v-if="inf.length && inf !== 'inf' && isCurses"
          variant="light"
          class="d-flex mx-1"
          size="sm"
          v-b-tooltip.hover
          :title="translations[13839]"
          @click="handleInfo()"
        >
          <svg class="w-3.5 h-3.5" fill="none" stroke="#64748B" viewBox="0 0 16 16" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="2" width="9" height="11" rx="1.5"></rect><rect x="2" y="4" width="9" height="11" rx="1.5"></rect><line x1="4" y1="7" x2="5.5" y2="7"></line><line x1="4" y1="9" x2="5.5" y2="9"></line><line x1="4" y1="11" x2="5.5" y2="11"></line></svg>
<!--          <b-icon icon="journals" font-scale="0.98" />-->
        </b-button>
        <b-dropdown
          @click="searchProfession()"
          class="ml-1"
          split
          split-variant="outline-primary"
          split-class="split-width"
          right
          :text="`${quantity}`"
          variant="primary" size="sm">
          <b-dropdown-item href="#" class="d-flex align-items-top text-nowrap"  @click.prevent="searchProfession()">
            <b-icon icon="list-ul" class="mr-2" />
            {{ translations[13500] }}
          </b-dropdown-item>
          <b-dropdown-item @click.prevent="searchProfessionMap()" href="#" class="d-flex align-items-top text-nowrap">
            <b-icon icon="geo-alt" class="mr-2" />
            {{ translations[13501] }}
          </b-dropdown-item>
          <b-dropdown-item v-if="isCurses" href="#" @click.prevent="onClickSubscribe">
            <b-icon icon="mailbox" class="mr-1"></b-icon> {{ translations[10450] }}
          </b-dropdown-item>
          <!--        <b-dropdown-item-->
          <!--          :href="isAuth ? `https://job-server.net/jobcentral/pdf?sid=${languageSid}&f=file&type=pdf&id=b${id}` : ''"-->
          <!--          v-if="pdf"-->
          <!--          v-b-modal="!isAuth ? 'not-auth-modal' : ''" class="d-flex align-items-top text-nowrap">-->
          <!--          <b-icon icon="file-earmark-pdf" class="mr-2" />-->
          <!--          {{ translations[10426] }}-->
          <!--          <span v-if="!isAuth" class="ml-auto" v-b-tooltip.hover title="Bitte registrieren, um diese Funktion zu nutzen.">-->
          <!--            <b-icon icon="shield-lock-fill" />-->
          <!--          </span>-->
          <!--        </b-dropdown-item>-->
          <b-dropdown-item
            :href="exportPdfUrl"
            v-if="pdf"
            target="_blank"
            class="d-flex align-items-top text-nowrap">
            <b-icon icon="file-earmark-pdf" class="mr-2" />
            {{ translations[10426] }}
          </b-dropdown-item>
          <b-dropdown-item :href="exportExcelUrl" target="_blank" class="d-flex align-items-top text-nowrap">
            <b-icon icon="file-earmark-excel" class="mr-2" />
            {{ translations[10449] }}
          </b-dropdown-item>
          <b-dropdown-divider v-if="isCurses" />
          <b-dropdown-item v-if="isCurses" href="#" @click.prevent="handleInfo">
            <b-icon icon="journals" class="mr-1"></b-icon> {{ translations[13502] }}
          </b-dropdown-item>
          <!--        <b-dropdown-item :href="isAuth ? onClickExcel : ''" target="_blank" v-b-modal="!isAuth ? 'not-auth-modal' : ''" class="d-flex align-items-top text-nowrap">-->
          <!--          <b-icon icon="file-earmark-pdf" class="mr-2" />-->
          <!--          {{ translations[10449] }}-->
          <!--          <span v-if="!isAuth" class="ml-auto" v-b-tooltip.hover title="Bitte registrieren, um diese Funktion zu nutzen.">-->
          <!--            <b-icon icon="shield-lock-fill" />-->
          <!--          </span>-->
          <!--        </b-dropdown-item>-->
        </b-dropdown>
      </div>
    </b-card-body>
  </b-card>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { ProfessionModule } from '@/store/modules/profession';
import { JobType } from '@/types/ProfessionType';
import { AppModule } from '@/store/modules/app';
import { MapModule } from '@/store/modules/map';
import { ClustersModule } from '@/store/modules/clusters';
import { handleError } from '@vue/runtime-dom';
import { NoticeModule } from '@/store/modules/notice';
import { groupCurses } from '@/config/configuration';
import QualificationLevelBars from '@/components/Home/QualificationLevelBars.vue';

@Component({
  components: { QualificationLevelBars },
  methods: { handleError },
})
export default class ProfessionsItem extends Vue {
  @Prop({ default: false }) top!: boolean;

  @Prop({ default: 0 }) private index!: number;

  @Prop({ default: '' }) private title!: string;

  @Prop({ default: '' }) private name!: string | string[];

  @Prop({ default: 0 }) private quantity!: number;

  @Prop({ default: 0 }) private plt!: number;

  @Prop({ default: 0 }) private pdf!: number;

  @Prop({ default: 0 }) private id!: number | string | string[];

  @Prop({ default: '' }) public sid!: string;

  @Prop({ default: '' }) private inf!: string | string[];

  @Prop({ default: null }) private rank!: string | number | null;

  @Prop({ default: false }) private showRankBars!: boolean;

  @Prop({ default: false }) isAuth!: boolean;

  @Prop({ default: '' }) languageSid!: string;

  get translations() {
    return AppModule.translation;
  }

  get normalizedProfessionIds(): string[] {
    if (Array.isArray(this.id)) {
      return this.id.map((x) => String(x).trim()).filter((x) => x);
    }

    return String(this.id)
      .split('~')
      .map((x) => x.trim())
      .filter((x) => x);
  }

  get professionIdValue(): string {
    return this.normalizedProfessionIds.join(',');
  }

  get primaryProfessionId(): string {
    return this.normalizedProfessionIds[0] || String(this.id);
  }

  get rankLevel(): 1 | 2 | 3 | null {
    const n = Number(this.rank);
    if (n === 1 || n === 2 || n === 3) return n as 1 | 2 | 3;
    return null;
  }

  get infTooltip(): string {
    if (!this.inf || this.inf === 'inf') return '';
    const infRaw = Array.isArray(this.inf) ? this.inf.join('<br />') : this.inf;
    if (!infRaw || infRaw === 'inf') return '';
    const items = infRaw.split('<br />').filter((item) => item.trim());
    const rawName = Array.isArray(this.name) ? this.name.join('<br />') : (this.name || this.title);
    const pureName = this.getPureName(rawName).replace(/\s*\|\|\|\s*/g, '<br />');
    const header = `<div style="font-weight: 600; margin-bottom: 8px;">${this.buildTooltipHeader(pureName)}</div>`;
    const listItems = items.map((item) => `<div style="display: flex; align-items: flex-start; margin-bottom: 4px;"><span style="margin-right: 8px;">•</span><span>${item}</span></div>`).join('');
    return `${header}<div class="tooltip-scrollable-content">${listItems}</div>`;
  }

  buildTooltipHeader(pureName: string): string {
    const names = pureName.split('<br />');
    const ids = this.normalizedProfessionIds;

    if (names.length > 1 && ids.length > 1) {
      return names.map((name, idx) => `${name} (${ids[idx] || ids[ids.length - 1]})`).join('<br />');
    }

    return `${pureName} (${ids.join(', ') || this.id})`;
  }

  getPureName(title: string): string {
    const patterns = [
      /^Berufe\s+(?:in\s+der|im|in)\s+/i,
      /^Berufe\s+/i,
    ];
    // const matchedPattern = patterns.find((pattern) => pattern.test(title));
    // if (matchedPattern) {
    //   return title.replace(matchedPattern, '');
    // }
    return title;
  }

  get exportBaseUrl() {
    if (process.env.NODE_ENV === 'production') {
      return '/api/v1/jobnews/form_job_list';
    }
    return 'https://jobnews.info/api/v1/jobnews/form_job_list';
  }

  get exportQueryParams() {
    const {
      jobSearch, jobParams, jobFilter, jobPagination, jobSort,
    } = ProfessionModule;
    const params: Record<string, string | number> = {
      sid: this.languageSid,
      jobnews_type: jobParams.jobnews_type ?? 1,
      profession_id: this.professionIdValue,
      location_id: jobSearch.location_id ?? '',
      radius: jobSearch.radius ?? 0,
      fulltext: jobSearch.fulltext ?? 0,
      q: jobSearch.q ?? '',
      mode: jobSearch.mode ?? 'AND',
      qmode: jobSearch.qmode ?? 2,
      start_education: 0,
      dejob: jobFilter.dejob ?? 0,
      recruit: jobFilter.recruit ?? 0,
      tmpjob: jobFilter.tmpjob ?? 0,
      workjob: jobFilter.workjob ?? 0,
      edujob: jobFilter.edujob ?? 0,
      praktikum: jobFilter.praktikum ?? 0,
      fulltime: jobFilter.fulltime ?? 0,
      parttime: jobFilter.parttime ?? 0,
      minijob: jobFilter.minijob ?? 0,
      seasonal: jobFilter.seasonal ?? 0,
      holiday: jobFilter.holiday ?? 0,
      time_factor: jobFilter.time_factor ?? 0,
      specialjob: jobFilter.specialjob ?? 0,
      disability_friendly: jobFilter.disability_friendly ?? 0,
      skill_level1: jobFilter.skill_level2 ?? 0,
      skill_level2: jobFilter.skill_level2 ?? 0,
      skill_level3: jobFilter.skill_level3 ?? 0,
      partner_jobs_only: jobFilter.partner_jobs_only ?? 0,
      other_jobs: jobFilter.other_jobs ?? 0,
      amsjob: jobFilter.amsjob ?? 0,
      email_contact: jobFilter.email_contact ?? 0,
      per_page: jobPagination.per_page ?? 20,
      page: jobPagination.page ?? 1,
      bajob: 0,
      extba: 0,
    };
    if (Array.isArray(jobSearch.month) && jobSearch.month.length) {
      params.month = jobSearch.month.join(',');
    }
    return params;
  }

  get exportExcelUrl() {
    const params = { ...this.exportQueryParams, export: 'excel' };
    const search = new URLSearchParams(
      Object.entries(params).reduce(
        (acc, [k, v]) => {
          acc[k] = String(v ?? '');
          return acc;
        },
        {} as Record<string, string>,
      ),
    ).toString();
    return `${this.exportBaseUrl}?${search}`;
  }

  get exportPdfUrl() {
    const params = { ...this.exportQueryParams, export: 'pdf' };
    const search = new URLSearchParams(
      Object.entries(params).reduce(
        (acc, [k, v]) => {
          acc[k] = String(v ?? '');
          return acc;
        },
        {} as Record<string, string>,
      ),
    ).toString();
    return `${this.exportBaseUrl}?${search}`;
  }

  get isCurses() {
    return groupCurses(this.sid);
  }

  searchProfession() {
    const selectedClusterId = Number(ProfessionModule.jobFilter.cluster_id || ClustersModule.jobClusterParams.cluster_id || 0);

    ProfessionModule.SetParamsDefault();
    if (selectedClusterId) {
      ProfessionModule.SetFilter({ obj: 'cluster_id', value: selectedClusterId });
      ProfessionModule.SetSearchTags({ tag: 'clusterTag', value: selectedClusterId });
      ClustersModule.SetClusterParams({ obj: 'cluster_id', value: selectedClusterId });
      const selectedCluster = (AppModule.settingPortal?.clusters || []).find((x: any) => x.id === selectedClusterId);
      ClustersModule.SetProfessionTitle(selectedCluster?.name || '');
    }
    ProfessionModule.SetProfessionId(this.professionIdValue);
    ProfessionModule.SetProfessionTitle(this.title);
    const professionTag = [{ id: this.professionIdValue, title: this.title, count: this.quantity }];
    ProfessionModule.SetSearchJobProfession(professionTag);
    ProfessionModule.SetSearchJobProfessionTitle(professionTag);
    ProfessionModule.SetSearch({ obj: 'profession_id', value: this.professionIdValue });
    ProfessionModule.SetJobType(JobType.search);
    AppModule.SetVisibleJobs(true);
  }

  searchProfessionMap() {
    ProfessionModule.SetParamsDefault();
    MapModule.SetProfessionMapId(this.professionIdValue);
    ProfessionModule.SetProfessionTitle(this.title);
    ProfessionModule.SetJobType(JobType.map);
    AppModule.SetVisibleMap(true);
  }

  handleInfo() {
    ProfessionModule.SetInformation({ title: this.title, info: this.inf, id: this.id });
    this.$root.$emit('bv::toggle::collapse', 'group-sidebar');
  }

  onClickSubscribe() {
    const objectParams = {
      id: this.primaryProfessionId,
      sid: this.sid,
      jobnews_type: 1,
    } as any;
    NoticeModule.SetSubscribeParams(objectParams);
    this.$bvModal.show('modal-subscribe');
  }
}
</script>

<style scoped>
/* Важливо для ellipsis у flex */
.professions-item {
  min-width: 0;
}

.min-w-0 {
  min-width: 0;
}

.flex-no-shrink {
  flex-shrink: 0;
}

.professions-item__rank-bars {
  display: inline-flex;
  line-height: 0;
}
</style>

<style>
.profession-info-tooltip .tooltip-inner {
  background-color: #1e293b !important;
  color: #ffffff !important;
  text-align: left !important;
  padding: 16px !important;
  border-radius: 8px !important;
  max-width: 450px !important;
  max-height: 300px !important;
  font-size: 13px !important;
  line-height: 1.4 !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
}

.profession-info-tooltip .tooltip-scrollable-content {
  max-height: 250px;
  overflow-y: auto;
  padding-right: 4px;
  padding-bottom: 8px;
}

.profession-info-tooltip .tooltip-scrollable-content::-webkit-scrollbar {
  width: 6px;
}

.profession-info-tooltip .tooltip-scrollable-content::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 3px;
}

.profession-info-tooltip .tooltip-scrollable-content::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
}

.profession-info-tooltip .tooltip-scrollable-content::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.4);
}

.profession-info-tooltip .arrow::before {
  border-left-color: #1e293b !important;
}

.profession-info-tooltip.bs-tooltip-right .arrow::before {
  border-right-color: #1e293b !important;
}

.profession-info-tooltip.bs-tooltip-top .arrow::before {
  border-top-color: #1e293b !important;
}

.profession-info-tooltip.bs-tooltip-bottom .arrow::before {
  border-bottom-color: #1e293b !important;
}
</style>
